import React from 'react';

import { StyleUtil } from '../../util';
import { ContentCardIcon, ContentCardIconType } from '../content-card-icon';
import classNames from './EABDContentCard.module.scss';

export interface ContentCardProps {
  readonly title: string;
  readonly iconType: ContentCardIconType;
  readonly isInFocus: boolean;
  readonly style?: React.CSSProperties;
  readonly children?: React.ReactNode;
}

export const ContentCard = React.memo<ContentCardProps>((props) => {
  const { title, iconType, isInFocus, style, children } = props;

  const ContainerClassNames = React.useMemo(() => {
    const containerClassNames: string[] = [classNames.container];

    if (!isInFocus) {
      containerClassNames.push(classNames.notInFocus);
    }

    return StyleUtil.mergeClassNames(containerClassNames);
  }, [isInFocus]);

  const HeaderElement = React.useMemo(() => {
    return (
      <div className={classNames.header}>
        <p className={classNames.title}>{title}</p>
        <ContentCardIcon type={iconType} />
      </div>
    );
  }, [title, iconType]);

  const SeparatorClassNames = React.useMemo(() => {
    const separatorClassNames: string[] = [classNames.separator];

    if (isInFocus) {
      separatorClassNames.push(classNames.active);
    }

    return StyleUtil.mergeClassNames(separatorClassNames);
  }, [isInFocus]);

  const SeparatorElement = React.useMemo(() => <div className={SeparatorClassNames} />, [SeparatorClassNames]);

  const ContentElement = React.useMemo(() => {
    return <div className={classNames.content}>{children}</div>;
  }, [children]);

  return (
    <div style={style} className={ContainerClassNames}>
      {HeaderElement}
      {SeparatorElement}
      {ContentElement}
    </div>
  );
});
